<div class="col gap-24 w100 h100">
    <div class="col w100 gap-16">
        <div class="row gap-16 space-between w100">
            <rr-icon class="roundicon" color="nutral" name="upload"></rr-icon>
            <!-- <img src="/images/default-agent.png" alt="" /> -->
        </div>
        <div class="w100 col gap-8">
            <h3 i18n>
                {{
                    extractedObject
                        ? "Document is ready to use"
                        : "Something useful you’d like to share?"
                }}
            </h3>
        </div>
    </div>
    <rr-tab-control i18n class="nopadding heigth100overflowhidden">
        <rr-tab step="1" label="File Upload" class="heigth100overflowhidden">
            <app-rag-file-upload
                [extractedObject]="extractedObject"
                (usecontent)="useUploadContent($event)"
                (close)="close()"
            ></app-rag-file-upload>
        </rr-tab>
        <rr-tab step="2" label="Raw Text Input" class="heigth100overflowhidden">
            <app-rag-raw-text
                (usecontent)="useUploadContent($event)"
                (close)="close()"
            ></app-rag-raw-text>
        </rr-tab>
        <rr-tab
            step="3"
            label="Stream Reference"
            class="heigth100overflowhidden"
        >
            <app-rag-stream-reference
                (close)="close()"
                (usecontent)="useUploadContent($event)"
            ></app-rag-stream-reference>
        </rr-tab>
    </rr-tab-control>
</div>
